import { Calendar} from "primereact/calendar";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useRef, useState } from "react";
import { CommuneDTO, DistrictDTO, FokontanyDTO, formatDateFr, RegionDTO, searchAutoComplete } from "@utils/appUtils.ts";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { communeList, districtList, fokontanyList, loadingCommune, loadingDistrict, loadingFokotany, loadingLocalisation, regionList } from "@core/slice/LocalisationSlice.ts";
import { AutoComplete, AutoCompleteChangeEvent } from "primereact/autocomplete";
import React from "react";
import { getAllRegions, getCommuneByDistrict, getDistrictByRegion, getFokontanysByCommune } from "@core/actions/localisationAction.ts";
import { Nullable } from "primereact/ts-helpers.js";
import { FetchStatusType } from "@core/modeles/model.ts";
import { natureLists } from "@core/slice/ComplaintSlice.ts";
import { NatureComplaintDTO } from "@modules/plaintes/plaintes.model.ts";
import { getExternStat } from "@core/actions/dashboardExterneAction.ts";
import { getAllNatureComplaint } from "@core/actions/complaintAction.ts";
import { formatUS } from "../dashbord.model.ts";

interface SearchFormProps{
  toRealod: boolean
  onSearch: (data: any) => void;
  setHasOneValueSearch: (a: boolean) => void
}


const SearchForm: React.FC<SearchFormProps> = ({
  toRealod,
  onSearch,
  setHasOneValueSearch
}) => {

  const dispatch = useAppDispatch();
  const dataRegion = useAppSelector(regionList);
  const dataDistrict = useAppSelector(districtList);
  const dataCommune = useAppSelector(communeList);
  const dataFokontany = useAppSelector(fokontanyList);
  const listsNature = useAppSelector(natureLists);

    // loader
  const loadingRegion = useAppSelector(loadingLocalisation);
  const districtLoader = useAppSelector(loadingDistrict);
  const communeLoader = useAppSelector(loadingCommune);
  const fokotanyLoader = useAppSelector(loadingFokotany);
  const [filteredRegions, setFilteredRegions] = useState<RegionDTO[]>([]);
  const [filteredDistricts, setFilteredDistricts] = useState<DistrictDTO[]>([]);
  const [filteredCommunes, setFilteredCommunes] = useState<CommuneDTO[]>([]);
  const [filteredFokontanys, setFilteredFokontanys] = useState<FokontanyDTO[]>([]);
  const [selectedRegion, setSelectedRegion] = useState<RegionDTO | null>(null);
  const [selectedDistrict, setSelectedDistrict] = useState<DistrictDTO | null>(null);
  const [selectedCommune, setSelectedCommune] = useState<CommuneDTO | null>(null);
  const [selectedFokontany, setSelectedFokontany] =useState<FokontanyDTO | null>(null);
  const [dateStart, setDateStart] = useState<Nullable<Date>>(null)
  const [dateEnd, setDateEnd] = useState<Nullable<Date>>(null)
  const [minDate, setMinDate] = useState<Date | undefined>(undefined)
  const [maxDate, setMaxDate] = useState<Date | undefined>(undefined)
  const [isCancel, setIsCancel] = useState<boolean>(false)
  const [typePlainte, setTypePlainte] = useState<NatureComplaintDTO>();
  const [dataRequest, setDataRequest] = useState<any>({
    dateDebut: '',
    dateFin: '',
    typePlainte: '',
    region: '',
    district:  '',
    commune:  '',
    fokontany:  '',
  });  

  const autoCompleteRefs = useRef<{ [key: string]: any }>({
    region: null,
    district: null,
    commune: null,
    fokontany: null,
  });

  React.useEffect(() => {
    setFilteredRegions(dataRegion);
  }, [dataRegion]);

  React.useEffect(() => {
    dispatch(getExternStat(dataRequest));

  }, [dispatch, dataRequest]);
  
  React.useEffect(() => {
    if (toRealod) {
      const filtre : any ={
        dateDebut: '',
        dateFin: '',
        typePlainte: '',
        region: '',
        district:  '',
        commune:  '',
        fokontany:  '',
      }
      dispatch(getExternStat(filtre));
    }
  }, [dispatch, toRealod]);

  React.useEffect(() => {
    dispatch(getAllNatureComplaint());
    dispatch(
      getAllRegions({
        page: 1,
        size: 22,
      })
    );
  }, [dispatch]);

  React.useEffect(() => {
    if (selectedRegion?.id) {
      const idRegion = selectedRegion.id;
      dispatch(
        getDistrictByRegion({
          page: 1,
          size: -1,
          region: idRegion.toString(),
        })
      );
    }
  }, [dispatch, selectedRegion]);
  
  React.useEffect(() => {
    if (selectedDistrict?.id) {
      const idDistrict = selectedDistrict.id;
      dispatch(
        getCommuneByDistrict({
          page: 1,
          size: -1,
          district: idDistrict.toString(),
        })
      );
    }
  }, [dispatch, selectedDistrict]);

  React.useEffect(() => {
    if (selectedCommune?.id) {
      const idCommune = selectedCommune.id;
      dispatch(
        getFokontanysByCommune({
          page: 1,
          size: -1,
          commune: idCommune.toString(),
        })
      );
    }
  }, [dispatch, selectedCommune]);

  const handleChangeRegion =(e: AutoCompleteChangeEvent) => {
    const selectedData = e.value;
    setSelectedRegion(selectedData);
    setSelectedDistrict(null);
    setSelectedCommune(null);
    setSelectedFokontany(null);
    showIsCancel(e.value, 'selectedRegion')
  };

  const handleChangeDistrict = (e: any) => {
    const selectedDistrict = e.value;
    setSelectedDistrict(selectedDistrict);
    setSelectedCommune(null);
    setSelectedFokontany(null);  
  };

  const handleChangeCommune = (e: any) => {
    const selectedCommuneCode = e.value;
    setSelectedCommune(selectedCommuneCode);
    setSelectedFokontany(null);    
  };

  const handleChangeFokontany = (e: DropdownChangeEvent) => {
    setSelectedFokontany(e.value); 
  };
  
  const handleChangeType = (e: DropdownChangeEvent) => {
    setTypePlainte(e.value);
    showIsCancel(e.value, 'typePlainte') 
  }

  const handleChangeDateStart = (e: any) => {
    setDateStart(e.value)
    setMinDate(e.value || undefined)
    showIsCancel(e.value, "dateStart")
  }

  const handleChangeDateEnd = (e: any) => {
    setDateEnd(e.value)
    setMaxDate(e.value || undefined)
    showIsCancel(e.value, "dateEnd")
  }

  const handleFocus = (
      type: string,
      data: any,
      setState: React.Dispatch<React.SetStateAction<any[]>>
  ) => {
      if (data.length > 0) {
        setState(data);
      }
  
      const ref = autoCompleteRefs.current[type];
      if (ref) {
        ref.show();
      }
  };
  
  const search = () => {
    const dateDebut = dateStart ? formatDateFr((dateStart as Date).toISOString()) : '';
    const dateFin = dateEnd ? formatDateFr((dateEnd as Date).toISOString()) : '';
    const data = {
      dateDebut: formatUS(dateDebut),
      dateFin: formatUS(dateFin),
      typePlainte: typePlainte?.id ?? '', 
      region: selectedRegion?.id ?? '',
      district: selectedDistrict?.id ?? '',
      commune: selectedCommune?.id ?? '',
      fokontany: selectedFokontany?.id ?? '',
    }
    setDataRequest (data);
    onSearch(data);
  };

  const cancel = () => {
    setHasOneValueSearch(false)
    setIsCancel(false)
    setSelectedRegion(null);
    setSelectedDistrict(null);
    setSelectedCommune(null);
    setSelectedFokontany(null);
    setDateStart(null);
    setDateEnd(null);
    setTypePlainte(undefined);
    setDataRequest({
      dateDebut: '',
      dateFin: '',
      typePlainte: '',
      region: '',
      district:  '',
      commune:  '',
      fokontany:  '',
    })
    
  }

  const showIsCancel = (data: any, key: 'dateStart' | 'dateEnd' | 'typePlainte' | 'selectedRegion') => {
    const state: { 
      dateStart: Nullable<Date>; 
      dateEnd: Nullable<Date>; 
      typePlainte: NatureComplaintDTO | undefined; 
      selectedRegion: RegionDTO | null; 
    } = {
      dateStart,
      dateEnd,
      typePlainte,
      selectedRegion
    };
    state[key] = data;
    const isAllEmpty =
      !state.dateStart &&
      !state.dateEnd &&
      state.typePlainte === undefined &&
      !state.selectedRegion;

    if (isAllEmpty) {
      setIsCancel(false);
    } else {
      setIsCancel(true);
    }
  };

  return (
    <div className="p-6 bg-white w-full rounded-lg shadow-md mx-auto">
      <div className="grid grid-cols-1 gap-4 md:gap-6">
        {/* Groupe 1 : Début et fin de période */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700">
                Début de la période
              </label>
              <Calendar 
                className="w-full" 
                placeholder="JJ/MM/AAAA"
                value={(dateStart)} 
                onChange={handleChangeDateStart}
                maxDate={maxDate}
                dateFormat="dd-mm-yy"
                showIcon />
            </div>
            <div>
              <label className="block text-gray-700">
                Fin de la période
              </label>
              <Calendar 
                className="w-full" 
                placeholder="JJ/MM/AAAA"
                value={dateEnd} 
                onChange={handleChangeDateEnd}
                dateFormat="dd-mm-yy"
                minDate={minDate}
                showIcon />
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {/* Groupe 2 : Type de plaintes */}
            <div>
              <label className="block text-gray-700">
                Type de plaintes
              </label>
              <Dropdown
                showClear={true}
                className="w-full"
                options={listsNature}
                value={typePlainte}
                onChange={handleChangeType}
                placeholder="Sélectionnez un type"
                optionLabel="name"
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700">Région</label>
              <AutoComplete
                ref={(el) => (autoCompleteRefs.current.region = el)}
                value={selectedRegion}
                className="w-full"
                suggestions={filteredRegions}
                completeMethod={(e) =>
                  searchAutoComplete(e, dataRegion, setFilteredRegions)
                }
                onChange={handleChangeRegion}
                onFocus={() =>
                  handleFocus("region", dataRegion, setFilteredRegions)
                }
                dropdown
                field="name"
                placeholder="Sélectionnez une région"
                showEmptyMessage={
                  loadingRegion === FetchStatusType.LOADING ||
                  loadingRegion === FetchStatusType.FAILED
                }
                emptyMessage={
                  loadingRegion === FetchStatusType.FAILED
                    ? "Erreur de chargement"
                    : "Chargement en cours"
                }
              />
            </div>
            <div>
              <label className="block text-gray-700 ">District</label>
              <AutoComplete
                ref={(el) => (autoCompleteRefs.current.district = el)}
                value={selectedDistrict}
                className="w-full"
                suggestions={filteredDistricts}
                completeMethod={(e) =>
                  searchAutoComplete(
                    e,
                    dataDistrict,
                    setFilteredDistricts
                  )
                }
                onChange={handleChangeDistrict}
                onFocus={() =>
                  handleFocus(
                    "district",
                    dataDistrict,
                    setFilteredDistricts
                  )
                }
                dropdown
                field="name"
                placeholder="Sélectionnez un district"
                showEmptyMessage={
                  districtLoader === FetchStatusType.LOADING ||
                  districtLoader === FetchStatusType.FAILED
                }
                emptyMessage={
                  districtLoader === FetchStatusType.FAILED
                    ? "Erreur de chargement"
                    : "Chargement en cours"
                }
                dropdownIcon={
                  districtLoader === FetchStatusType.LOADING ? (
                    <i className="pi pi-spin pi-spinner" />
                  ) : (
                    <i
                      className="pi pi-angle-down"
                      style={{ fontSize: "1.2rem" }}
                    />
                  )
                }
                disabled={districtLoader === FetchStatusType.LOADING}
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 ">Commune</label>
              <AutoComplete
                ref={(el) => (autoCompleteRefs.current.commune = el)}
                value={selectedCommune}
                className="w-full"
                suggestions={filteredCommunes}
                completeMethod={(e) =>
                  searchAutoComplete(e, dataCommune, setFilteredCommunes)
                }
                onChange={handleChangeCommune}
                onFocus={() =>
                  handleFocus("commune", dataCommune, setFilteredCommunes)
                }
                dropdown
                field="name"
                placeholder="Sélectionnez une commune"
                showEmptyMessage={
                  communeLoader === FetchStatusType.LOADING ||
                  communeLoader === FetchStatusType.FAILED
                }
                emptyMessage={
                  communeLoader === FetchStatusType.FAILED
                    ? "Erreur de chargement"
                    : "Chargement en cours"
                }
                dropdownIcon={
                  communeLoader === FetchStatusType.LOADING ? (
                    <i className="pi pi-spin pi-spinner" />
                  ) : (
                    <i
                      className="pi pi-angle-down"
                      style={{ fontSize: "1.2rem" }}
                    />
                  )
                }
                disabled={communeLoader === FetchStatusType.LOADING}
              />
            </div>
            <div>
              <label className="block text-gray-700">Fokontany</label>
              <AutoComplete
                ref={(el) => (autoCompleteRefs.current.fokontany = el)}
                value={selectedFokontany}
                className="w-full"
                suggestions={filteredFokontanys}
                completeMethod={(e) =>
                  searchAutoComplete(
                    e,
                    dataFokontany,
                    setFilteredFokontanys
                  )
                }
                onChange={handleChangeFokontany}
                onFocus={() =>
                  handleFocus(
                    "fokontany",
                    dataFokontany,
                    setFilteredFokontanys
                  )
                }
                dropdown
                field="name"
                placeholder="Sélectionnez une fokontany"
                showEmptyMessage={
                  fokotanyLoader === FetchStatusType.LOADING ||
                  fokotanyLoader === FetchStatusType.FAILED
                }
                emptyMessage={
                  fokotanyLoader === FetchStatusType.FAILED
                    ? "Erreur de chargement"
                    : "Chargement en cours"
                }
                dropdownIcon={
                  fokotanyLoader === FetchStatusType.LOADING ? (
                    <i className="pi pi-spin pi-spinner" />
                  ) : (
                    <i
                      className="pi pi-angle-down"
                      style={{ fontSize: "1.2rem" }}
                    />
                  )
                }
                disabled={fokotanyLoader === FetchStatusType.LOADING}
              />
            </div>
          </div>
        </div>

        {/* Bouton Rechercher */}
        <div className="mt-6 flex justify-end gap-4">
          {isCancel && (<Button
            label="Annuler"
            className="btn btn-secondary w-[120px] py-2 px-4"
            onClick={() => cancel()}
          />)}
          <Button 
            onClick={search} 
            label="Rechercher" 
            className="btn-primary w-[120px] bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md gap-2" 
          />
        </div>
      </div>
    </div>
  );
}

export default SearchForm;
